import { wishlistColors } from './relationshipConfig';
import useScrollLock from '@/hooks/useScrollLock';

import { Button } from '@/components/ui/button';
export default function CreateWishlistModal({ 
  isOpen, 
  onClose, 
  onSubmit, 
  darkMode 
}) {
  useScrollLock(isOpen);
  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    await onSubmit({
      name: formData.get('name'),
      color: formData.get('color')
    });
  };

  return (
    <div 
      className="fixed inset-0 z-[10000] flex items-center justify-center p-4"
      style={{
        background: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(4px)'
      }}
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-md rounded-2xl shadow-2xl p-6"
        style={{ background: darkMode.isDark ? '#2D4354' : 'white' }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif', color: darkMode.textPrimary }}>
          Create Wishlist
        </h3>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium block mb-2" style={{ color: darkMode.textPrimary }}>
              Wishlist Name
            </label>
            <input
              type="text"
              name="name"
              placeholder="e.g., Holiday 2025, Birthday Ideas"
              className="w-full px-4 py-2 rounded-lg border"
              style={{
                background: darkMode.isDark ? 'rgba(255, 255, 255, 0.1)' : 'white',
                color: darkMode.textPrimary,
                borderColor: darkMode.isDark ? '#FED7A5' : '#D1D5DB'
              }}
              required
            />
          </div>

          <div>
            <label className="text-sm font-medium block mb-2" style={{ color: darkMode.textPrimary }}>
              Choose Color
            </label>
            <div className="grid grid-cols-4 gap-3">
              {wishlistColors.map((color, idx) => (
                <label key={color.value} className="relative">
                  <input
                    type="radio"
                    name="color"
                    value={color.value}
                    defaultChecked={idx === 0}
                    className="sr-only peer"
                  />
                  <div
                    className="aspect-square rounded-lg cursor-pointer transition-all hover:scale-110 peer-checked:ring-4 peer-checked:ring-offset-2"
                    style={{
                      background: color.value,
                      ringColor: darkMode.isDark ? '#FED7A5' : '#20212B'
                    }}
                    title={color.name}
                  />
                </label>
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              onClick={onClose}
              className="flex-1"
              style={{
                background: darkMode.isDark ? 'rgba(255, 255, 255, 0.1)' : '#F3F4F6',
                color: darkMode.textPrimary
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="flex-1"
              style={{ background: '#9E6752', color: 'white' }}
            >
              Create
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
